<template>
    <div id="page" class="page">

      <input type="text" hidden :value="recup_id(id)">
      
      

        <interne_menu></interne_menu>
               
        <section id="download-4" class="bg-fixed p-top-160 pro_m download-section division ">
            <div class="container">
                <div class="row">
                                
                    <!-- DOWNLOAD TEXT -->
                    <div class="col-lg-10 offset-lg-1">	
                        <div class="download-txt" > 
                  

                              <div class="d_pic">
                                <img :src="'https://carte.abidjan.net/images/img_agence/' + agence.image" class="img_card" v-if="agence.image.length > 0">
                                <img src="@/assets/images/noimage1.png" class="img_card3" v-if="agence.image.length <= 0">
                               
                              
                              </div> 
                              
                                                        
                            <!-- Title -->
                            <h2 class="h2-xs nom_loc"> {{ agence.nom }} </h2>
                             <!-- <div class="category"><a href="" class="cat" >{{agence.categorie}}</a></div>-->
                            <!-- Text -->
                                                    
                         
                                   
                        </div>
                    </div>	 <!-- END DOWNLOAD TEXT -->               
                
                    
                </div>	  <!-- End row -->

                
                
            </div>	   <!-- End container -->		
        </section>


        <!-- Ma carte virtuelle -->
        <section id="pro" class="bg-scroll wide-60 h_1 content-section division sct_bck pro_part  sub_section ">
            <div class="container">


            <div class="row">
                  <div class="col-lg-12 col-xl-12 ">	
                    <div class="row">

                    
                      <!-- PRICE PLAN FREE -->
                      <div class="col-md-12 " data-animation="fadeInRight" data-animation-delay="400">	                       

                        <div class="pricing-table m-bottom-20">		
                                  
                          <table class="table table-bordered table-striped table-hover">
                            <thead>
                              
                            </thead>
                            <tbody>
                              <tr>
                                <th scope="row">Agence:</th>
                                <td width="75%">{{ agence.nom }}</td>
                               
                              </tr>
                              <tr>
                                <th scope="row">Adresse:</th>
                                <td >{{ agence.adresse }}</td>
                               
                              </tr>

                              <tr>
                                <th scope="row">Téléphone:</th>
                                <td>{{agence.telephone}}</td>
                                
                              </tr>

                              <tr>
                                <th scope="row">Email:</th>
                                <td>{{agence.email}}</td>
                               
                              </tr>

                              <tr>
                                <th scope="row">Horaire d’ouverture:</th>
                                <td>du lundi au vendredi: {{agence.horaire1}} | Samedi : {{agence.horaire2}}</td>
                               
                              
                              </tr>


                              
                              
                            </tbody>
                          </table>
                                           
                        </div>


                      </div>	<!-- END PRICE PLAN FREE -->



                    </div>	

                  </div>	
                  </div>

                    <div class="row">

                      <div class="col-lg-6 col-xl-6 ">
                            <div class="pricing-table m-bottom-20 tb2">	
                              <img :src="'https://carte.abidjan.net/images/img_agence/' + agence.image" class="img_card_2" v-if="agence.image.length > 0">
                              <img src="@/assets/images/noimages.png" class="img_card_2" v-if="agence.image.length <= 0">
                              
                            </div>
                        </div>


                        <div class="col-lg-6 col-xl-6 ">
                            <div class="pricing-table m-bottom-20 tb2">	
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3972.5526945310335!2d-4.0024464842035306!3d5.332231196131949!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xfc1eb47944c0395%3A0xbfae134df6015c32!2sAgence%20Weblogy%20Cocody!5e0!3m2!1sfr!2sci!4v1675340302915!5m2!1sfr!2sci" width="100%" height="340" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                            </div>
                        </div>
                    </div>
                
            </div>	   <!-- End container -->		
        </section>	
        <!-- END Ma carte virtuelle -->  
        <footer_menu></footer_menu>
       
      
    </div>


  
</template>


<script>

import interne_menu  from '../components/interne_menu.vue';
import footer_menu  from '../components/footer_menu.vue';
import axios from 'axios';


export default{ 


  props: ['id'],
  data(){
           
    return{
      reponse: "",

      agence: {
        nom: "",
        adresse: "",
        telephone: "",
        email: "",
        horaire1: "",
        horaire2: "",
        image: "",
       
      },

      catego: {
        nom: "",
      }      
    }

    
  }, 


  methods:{

    recup_id(id){

      const slug = id;
      const id_rec = slug.split('-')[slug.split('-').length - 1];
      //console.log(id_rec); // Output: '197'

      this.reponse = id_rec;
      return id_rec;
    },

    // add two paramater in v-html
    renderHTML(remise, designation) {
      return `${remise} ${designation}`
    },

    //seeting function api

    getAgence(){
                var dataSend = new FormData() ;
                dataSend.append("id", this.reponse);

                axios.post("https://carte.abidjan.net/assets-apaym/detail_agence.php",dataSend).then((res)=> {
                    //console.log(res.data)
                    this.agence.nom = res.data[0].nom ;
                    this.agence.adresse = res.data[0].adresse ;
                    this.agence.telephone = res.data[0].tel ;
                    this.agence.email = res.data[0].email ;
                    this.agence.horaire1 = res.data[0].horaire1 ;
                    this.agence.horaire2 = res.data[0].horaire2 ;
                    this.agence.image = res.data[0].pho ;
                                    

                }).catch(error => {
                    console.log(error)
                })
            },

 
  },
  
  name :'privileges-details',
    
    components:{
      'interne_menu' :interne_menu,
      'footer_menu' :footer_menu,
    } ,

    mounted(){
      //console.log(this.$route.params.slug);
      console.log(this.reponse)
      this.getAgence() ;

    },
    
  
  
}
</script>



<style scoped>
  
  .img_card_2 {
    max-width: 518px !important;
    width: 100%;
}

.pricing-table {
 padding: 11px;
}
.table {
    width: 100%;
    max-width: 100%;
    margin-bottom: 0;
    background-color: transparent;
}
.tb2 {
 padding: 10px !important;
}

.pricing-table {
    background-color: #fff;
    border: 1px solid #f1efef !important;
}



.nom_loc{
  line-height: 0.57143rem;
  margin-bottom: 25px;
  
}
.d_pic{
  width: 200px;
  height: 200px;
  background: grey;
  margin: auto;
  border-radius: 50%;
  overflow: hidden;
  margin-bottom:30px;
  border: 1px solid #efefef;
}
.img_card{
  max-width: 210px !important;
  zoom: 142%;
  margin-left: -30px;
}
.img_card3{
  max-width: 210px !important;

}
.wide-60 {
    padding-top: 60px !important;
    padding-bottom: 60px;
}




.sub_section {
   background: #f6f6f6;
    padding-top: 30px!important;
    padding-bottom: 60px!important;
}

.wide-60 {
    padding-top: 190px;
    padding-bottom: 60px;
}

h2.h2-xs {
    font-size: 4.25rem !important;
}

#download-4 p {
     padding: 0 0% !important; 
}



.pro_m{
    background-image: url(@/assets/images/map-bg.png);
    background-size: auto;
}
h2.h2-xs {
    font-size: 2.6rem !important;
}


@media screen and (max-width: 767px) {
  .d_pic{
      margin-top: 50px;
  }
 

    .pro_m{
    background-image: url(@/assets/images/map-bg.png);
    padding-top: 30px !important;
}

.p-top-160 {
    padding-top: 100px;
}
.nom_loc{

    line-height: 1.1 !important;
}
.wide-60 {
    padding-top: 0px !important;
    padding-bottom: 60px;
}

}






</style>

